import type { FaireProductEntity } from "../../entity_types/product";

export const p_b2atu238tm: FaireProductEntity = {
  token: "p_b2atu238tm",
  type: "product",
  name: "Hand-painted Mahjong Claw Hair Clip | Eco-Friendly",
  brandToken: "b_z4cmjuda3k",
  brandName: "Solar Eclipse",
  imageUrl:
    "https://cdn.faire.com/fastly/96ed9109d8aa9e72865ec3bf081d67eb2e50bb89e48e5e74b297a62acff125f7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07949c841f6d1d40279aa8a99ce4126add4e0834ebaec52002f57fca53e254bb.jpeg",
    "https://cdn.faire.com/fastly/0716f5ba9d76b672c537c2d9756aa94fe5e143a87dab8c405bd2b37a5ef25c25.jpeg",
    "https://cdn.faire.com/fastly/0065da2ca65045b36480cd1589397ab59ef81b746c301b2e8a91817ffef58aea.jpeg",
  ],
  priceDollars: 14,
  description:
    "Hand-painted by our Solar Eclipse artists, our original hair claw clip is crafted in small batches. It's designed to upgrade your routine and be treasured for years to come. \n\nDesigned in New York City, this clip is double-sided, for a perfect look from all angles.\n\nHandmade with our signature biodegradable acetate made from recycled wood pulp, it effortlessly holds hair for a secure all-day style.\n\n\n\nKey Features\n\nOriginal Design: Copyright original design you won't find anywhere else!\n\nHand-painted: Each clip is carefully hand-painted by our Solar Eclipse artists.\n\nCellulose Acetate: Crafted from a eco-friendly, biodegradable material made from recycled wood pulp.\n\nExtra Strong Hinge: Promotes long-lasting styles for all-day wear.\n\nSustainable Packaging: 100% recyclable & plastic-free packaging\n\n\n\nWe are very proud of our original art. Our copyright designs are protected internationally by intellectual property law.\n",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:36.051Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
